module.exports = __webpack_public_path__ + "static/media/soccerLineUp.b9b008ec.png";